/**
 * Reopening Reason Entity
 *
 * Represents a predefined reason for reopening a closed case.
 * Used in the Reopen Case modal dropdown.
 */
export class ReopeningReasonEntity {
  public id!: string; // Encrypted UUID
  public name!: string;
  public sortOrder!: number;
  public isActive!: boolean;

  constructor(partial?: Partial<ReopeningReasonEntity>) {
    if (partial) {
      Object.assign(this, partial);
    }
  }
}
